module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact"
  }, [_c('div', {
    staticClass: "columns"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "is-4 column"
  }, [_c('bmv-form')], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "is-4 is-offset-2 column"
  }, [_c('div', {
    staticClass: "contactbox"
  }, [_c('p', [_c('b', [_vm._v("Be More Visible, Inc.")]), _c('br'), _vm._v("\n      3022 N. Clifton Ave. #1"), _c('br'), _vm._v("\n      Chicago, IL 60657")]), _vm._v(" "), _c('p', [_vm._v("312-259-6410")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "mailto:info@bemorevisible.com"
    }
  }, [_vm._v("info@bemorevisible.com")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-016fc434!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contact.vue
// module id = 105
// module chunks = 2